import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import TestimonialCarousel from '../../components/TestimonialCarousel/TestimonialCarousel';
import './Testimonials.css';

const Testimonials = () => {
  const [filter, setFilter] = useState('all');

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      position: 'CEO',
      company: 'TechStart Inc.',
      image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'web-development',
      text: 'Working with this company has been an absolute game-changer for our business. Their expertise in web development and digital marketing helped us increase our online presence by 300%. The team is professional, responsive, and truly understands our needs.',
      project: 'E-commerce Platform Development',
      date: '2024-01-15'
    },
    {
      id: 2,
      name: 'Michael Chen',
      position: 'Marketing Director',
      company: 'Global Solutions',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'mobile-development',
      text: 'The mobile app they developed for us exceeded all expectations. The user interface is intuitive, the performance is outstanding, and our customers love it. We saw a 250% increase in user engagement within the first month of launch.',
      project: 'Customer Engagement Mobile App',
      date: '2024-01-10'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      position: 'Founder',
      company: 'Creative Agency',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'digital-marketing',
      text: 'Their digital marketing strategies transformed our brand visibility. We went from struggling to get noticed to becoming a recognized name in our industry. The ROI on our marketing investment has been phenomenal.',
      project: 'Brand Awareness Campaign',
      date: '2024-01-05'
    },
    {
      id: 4,
      name: 'David Thompson',
      position: 'CTO',
      company: 'Innovation Labs',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'cloud-solutions',
      text: 'The cloud migration project was handled flawlessly. They managed the entire process with minimal downtime and significant cost savings. Our system performance improved dramatically, and we now have the scalability we needed.',
      project: 'Cloud Infrastructure Migration',
      date: '2023-12-20'
    },
    {
      id: 5,
      name: 'Lisa Wang',
      position: 'Operations Manager',
      company: 'Retail Plus',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'web-development',
      text: 'From consultation to implementation, every step was handled with utmost professionalism. The e-commerce platform they built for us has streamlined our operations and boosted our sales by 180%. Highly recommended!',
      project: 'E-commerce Platform Redesign',
      date: '2023-12-15'
    },
    {
      id: 6,
      name: 'Robert Martinez',
      position: 'Product Manager',
      company: 'FinTech Solutions',
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'ui-ux-design',
      text: 'The UI/UX design work they delivered was exceptional. Our user satisfaction scores increased by 40% after implementing their design recommendations. The attention to detail and user-centric approach was impressive.',
      project: 'Financial Dashboard Redesign',
      date: '2023-12-10'
    },
    {
      id: 7,
      name: 'Jennifer Adams',
      position: 'VP of Technology',
      company: 'Healthcare Innovations',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'mobile-development',
      text: 'They developed a complex healthcare management app that meets all regulatory requirements while being user-friendly. The project was delivered on time and within budget. Outstanding work!',
      project: 'Healthcare Management App',
      date: '2023-12-05'
    },
    {
      id: 8,
      name: 'Mark Wilson',
      position: 'Founder',
      company: 'EduTech Startup',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'web-development',
      text: 'Our online learning platform wouldn\'t be what it is today without their expertise. They built a scalable, feature-rich platform that handles thousands of concurrent users seamlessly. Excellent technical skills and project management.',
      project: 'Online Learning Platform',
      date: '2023-11-30'
    },
    {
      id: 9,
      name: 'Amanda Foster',
      position: 'Marketing Manager',
      company: 'Fashion Forward',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
      rating: 5,
      category: 'digital-marketing',
      text: 'Their social media marketing campaign increased our brand engagement by 400%. The creative content and strategic approach helped us reach our target audience effectively. We\'ve seen tremendous growth in our online community.',
      project: 'Social Media Marketing Campaign',
      date: '2023-11-25'
    }
  ];

  const categories = [
    { key: 'all', label: 'All Testimonials' },
    { key: 'residential-solar', label: 'Residential Solar' },
    { key: 'commercial-solar', label: 'Commercial Solar' },
    { key: 'energy-storage', label: 'Energy Storage' },
    { key: 'maintenance', label: 'Maintenance' }
  ];

  const filteredTestimonials = filter === 'all' 
    ? testimonials 
    : testimonials.filter(testimonial => testimonial.category === filter);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        ★
      </span>
    ));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const stats = [
    { number: '150+', label: 'Happy Clients', icon: 'fas fa-users' },
    { number: '500+', label: 'Projects Completed', icon: 'fas fa-project-diagram' },
    { number: '98%', label: 'Client Satisfaction', icon: 'fas fa-heart' },
    { number: '24/7', label: 'Support Available', icon: 'fas fa-headset' }
  ];

  return (
    <>
      <Helmet>
        <title>Customer Testimonials - What Our Solar Customers Say</title>
        <meta name="description" content="Read testimonials from our satisfied solar customers. Discover how we've helped homes and businesses save money with our solar energy solutions." />
        <meta name="keywords" content="solar testimonials, customer reviews, solar energy feedback, success stories, solar installation reviews" />
      </Helmet>

      <div className="testimonials-page">
        {/* Hero Section */}
        <section className="testimonials-hero">
          <div className="testimonials-hero-overlay"></div>
          <div className="container">
            <div className="testimonials-hero-content">
              <h1>Client Testimonials</h1>
              <p>
                Don't just take our word for it - hear what our clients have to say about 
                working with us and the results we've delivered
              </p>
            </div>
          </div>
        </section>

        {/* Featured Testimonials Carousel */}
        <section className="section featured-testimonials">
          <div className="container">
            <div className="section-header text-center">
              <h2>Featured Success Stories</h2>
              <p>Highlighting some of our most impactful client partnerships</p>
            </div>
            <TestimonialCarousel />
          </div>
        </section>

        {/* Stats Section */}
        <section className="section section-alt stats-section">
          <div className="container">
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-card">
                  <div className="stat-icon">
                    <i className={stat.icon}></i>
                  </div>
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* All Testimonials */}
        <section className="section all-testimonials">
          <div className="container">
            <div className="section-header text-center">
              <h2>All Client Reviews</h2>
              <p>Browse through all our client testimonials by service category</p>
            </div>

            {/* Filter Buttons */}
            <div className="filter-section">
              <div className="filter-buttons">
                {categories.map((category) => (
                  <button
                    key={category.key}
                    className={`filter-btn ${filter === category.key ? 'active' : ''}`}
                    onClick={() => setFilter(category.key)}
                  >
                    {category.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Testimonials Grid */}
            <div className="testimonials-grid">
              {filteredTestimonials.map((testimonial) => (
                <div key={testimonial.id} className="testimonial-card">
                  <div className="testimonial-header">
                    <div className="client-info">
                      <div className="client-image">
                        <img src={testimonial.image} alt={testimonial.name} loading="lazy" />
                      </div>
                      <div className="client-details">
                        <h4 className="client-name">{testimonial.name}</h4>
                        <p className="client-position">{testimonial.position}</p>
                        <p className="client-company">{testimonial.company}</p>
                      </div>
                    </div>
                    <div className="rating">
                      {renderStars(testimonial.rating)}
                    </div>
                  </div>

                  <div className="testimonial-content">
                    <div className="quote-icon">"</div>
                    <p className="testimonial-text">{testimonial.text}</p>
                  </div>

                  <div className="testimonial-footer">
                    <div className="project-info">
                      <span className="project-label">Project:</span>
                      <span className="project-name">{testimonial.project}</span>
                    </div>
                    <div className="testimonial-date">
                      {formatDate(testimonial.date)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section section-alt cta-section">
          <div className="container">
            <div className="cta-content text-center">
              <h2>Ready to Join Our Success Stories?</h2>
              <p>
                Let's work together to create your own success story. 
                Contact us today to discuss your project requirements.
              </p>
              <div className="cta-buttons">
                <a href="/contact" className="btn btn-primary">
                  Start Your Project
                </a>
                <a href="/services" className="btn btn-outline">
                  View Our Services
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Testimonials;